import { jsx as _jsx } from "react/jsx-runtime";
import { useSourSearchContext } from '../../context/use-sour-search-context';
export const ResultWrapper = ({ children, onRedirect }) => {
    const { highlightActive } = useSourSearchContext();
    return (_jsx("div", { className: `${highlightActive ? 'hover:bg-primary-50 hover:rounded' : ''} flex min-h-10 cursor-pointer flex-row items-center justify-start space-x-2 border-b-[0.5px] border-slate-200 p-1 px-2 text-sm md:min-h-0 md:border-none`, onClick: onRedirect, children: children }));
};
//# sourceMappingURL=result-wrapper.js.map